module.exports = {
  domain: {
    desktop: "4njbets.stg.use2.racing.fndlext.net",
    mobile: "4njbets.stg.use2.racing.fndlext.net",
    talentPicks: "4njbets.stg.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.us.betfair.com"
  },
  service_host: "service.stg.use2.racing.fndlext.net",
  recaptchaID: "6LeIYBcqAAAAAE2wDhSub9Ic8oeidAiiUt4gYM4a",
  recaptchaIdNative: "6LfRQloqAAAAABY9v2RydlB10Lfgb5ODmvygHy3G"
};
